/* eslint-disable no-nested-ternary */
import chroma from "chroma-js";
import React from "react";
import ReactSelect, { StylesConfig } from "react-select";

export interface SelectOptionProps {
  value: string;
  label: string;
  color: string;
}

export interface Props {
  backgroundColor: string;
  optionList: SelectOptionProps[];
  selectedOption?: SelectOptionProps[];
  placeHolder?: string;
  hidden?: boolean;
  isMulti?: boolean;
}

export const Select: React.FC<Props> = ({
  backgroundColor,
  optionList,
  selectedOption,
  isMulti = true,
  placeHolder = "",
  ...props
}: Props) => {
  const customStyles: StylesConfig<SelectOptionProps, true> = {
    control: (styles, { isFocused }) => ({
      ...styles,
      minHeight: "4rem",
      borderWidth: "0px",
      borderRadius: "10px",
      backgroundColor: backgroundColor || "#ffffff21",
      boxShadow: isFocused ? "#fff" : "none",
      ":active": {
        ...styles[":active"],
        boxShadow: "#fff",
      },
      fontFamily: "Quicksand",
      fontWeight: 500,
      fontSize: "1.2rem",
      fontStyle: "normal",
      paddingLeft: "4px",
      paddingRight: "4px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? chroma.contrast(color, "white") > 2
            ? "white"
            : "black"
          : data.color,
        cursor: isDisabled ? "not-allowed" : "default",
        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        padding: "5px 10px",
        backgroundColor: `${data.color}`,
        borderRadius: "50px",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "white",
      fontFamily: "Quicksand",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "22px",
      fontStyle: "normal",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      ':hover': {
        backgroundColor: data.color
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "#3D3938",
      fontFamily: "Quicksand",
      fontWeight: 500,
      fontSize: "1.2rem",
      fontStyle: "normal",
      paddingLeft: "4px",
      paddingRight: "4px",
      opacity: 0.3,
    }),
  };

  return (
    <>
      <ReactSelect
        backspaceRemovesValue={false}
        defaultValue={selectedOption}
        placeholder={placeHolder}
        styles={customStyles}
        options={optionList}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
        }}
        {...(isMulti ? { isMulti: true } : {})}
        {...props}
      />
    </>
  );
};
